import { useModal } from "../../hooks/useModal.js";
import { Modal } from "./Modal.jsx";
import { ContactForm } from "./ContactForm.jsx";
import { ContactMessage } from "./ContactMessage.jsx";
import { useState } from "react";

export const Contacto = ({ text, className }) => {
  const [isOpen, openModal, closeModal] = useModal(false);
  const [displayForm, setDisplayForm] = useState(true);

  const handleOnSuccess = () => {
    setDisplayForm(false);
  };

  const handleCloseModal = () => {
    closeModal();
    setDisplayForm(true);
  };

  return (
    <div>
      <button onClick={openModal} className={className}>
        {text}
      </button>
      <Modal
        isOpen={isOpen}
        closeModal={handleCloseModal}
        bkgColorModalCointainer={displayForm}
      >
        {displayForm ? (
          <ContactForm onSuccess={handleOnSuccess} />
        ) : (
          <ContactMessage />
        )}
      </Modal>
    </div>
  );
};
